import { render, staticRenderFns } from "./FormProjectLibraryCost.vue?vue&type=template&id=2b1074f8&"
import script from "./FormProjectLibraryCost.vue?vue&type=script&lang=js&"
export * from "./FormProjectLibraryCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports